import Vue from "vue";
import store from "@/store";
import { StompClient } from "@/service/StompClient";
import { Utils } from "@/service/util";

export class SocketControllers {
  uketsukeCd: string;
  yoyakuNo: string;
  socketPath: string;
  socket: StompClient;
  subscribeList: any = {};
  private subscriptionDefinitions: { [key: string]: { destination: string; callback: any } } = {};
  private removeConnectedListener: (() => void) | null = null;
  private disposed = false;
  private hasConnected = false;
  private reconnectCallbacks: Array<() => void> = [];
  utils = new Utils();
  isUserMode: boolean = false;

  // 各ソケット接続先の設定を用意
  socketMap: any = {
    workSubscription              : { "main": "/connect/factory/work-order/"   , "sub": "/completed"  },
    workprogressSubscription      : { "main": "/connect/workprogress/"         , "sub": ""            },
    completeSubscription          : { "main": "/connect/completed/"            , "sub": ""            },
    updateCourseSubscription      : { "main": "/connect/inspections/"          , "sub": "/reload"     },
    // 受信ソケット:ソケット仮07
    inspectSubscription           : { "main": "/connect/inspect/"              , "sub": "/completed"  },
    buhinSubscription             : { "main": "/connect/inspect-buhin-change/" , "sub": "/completed"  },
    timeSubscription              : { "main": "/connect/extends/"              , "sub": "/inspect-time"  },
    navSubscription               : { "main": "/connect/customer/navigations/" , "sub": ""            },
    kensaHiyouSubscription        : { "main": "/connect/customer/kensaHiyou/"  , "sub": "/reload"     },
    estimateListSubscription      : { "main": "/connect/customer/edit-price/"  , "sub": "/completed"  },
    questionnaireSubscription     : { "main": "/connect/customer/questionnaire-extreme/" , "sub": "/completed`"  },
    youtoSubscription             : { "main": "/connect/customer/reservation/" , "sub": "/omona-youto"  },
    confirmationSubscription      : { "main": "/connect/customer/reservation/" , "sub": "/confirmation-before-entry"  },
    mileageSubscription           : { "main": "/connect/reservation/"          , "sub": "/soukoukm"   },
    memoSubscription              : { "main": "/connect/reservation/"          , "sub": "/sknmemo"    },
    inspectSubscriptionDetail     : { "main": "/connect/reservation/"          , "sub": "/inspectionDetailCompleted"  },
    frontSubscription             : { "main": "/connect/reservation/"          , "sub": "/front-tantousha"  },
    ak7Subscribe                  : { "main": "/connect/payments/"             , "sub": ""            },
    jizenRecommendSubscribe       : { "main": "/connect/jizen-recommend/"      , "sub": "/completed"  },
    doTenkenSubscribe             : { "main": "/connect/customer/inspections/" , "sub": "/completed"  },
    inspectSeibiSubscribe         : { "main": "/connect/inspect-seibi/"        , "sub": "/completed"  },
    optionSubscription            : { "main": "/connect/customer/option/"      , "sub": "/completed"  },
    couponSubscription            : { "main": "/connect/customer/coupon/"      , "sub": "/completed"  },
    jizenDisplayOrderSubscription : { "main": "/connect/jizen-display-order/"  , "sub": "/completed"  },
    shohiyouSubscriptionComp      : { "main": "/connect/customer/shohiyou/"    , "sub": "/completed"  },
    extendsImageSubscription      : { "main": "/connect/extends-image/"        , "sub" : ""           }
  };

  /** 各ソケットの情報
   * workSubscription         : 受信ソケット:02作業指示の編集（するしない後日および部品代）
   * workprogressSubscription : 受信ソケット:ソケット仮33
   * completeSubscription     : 受信ソケット:32車検中止
   * updateCourseSubscription : 受信ソケット:08車検コース変更による再描画指示
   * クイック見積もりにつき別途宣言 : 受信ソケット:ソケット仮07
   * inspectSubscription      : 受信ソケット:ソケット仮04
   * buhinSubscription        : 受信ソケット:ソケット仮22
   * timeSubscription         : 受信ソケット:ソケット仮10 // 各所 -> 車検進行状況の更新
   * navSubscription          : 受信ソケット:ソケット仮14
   * kensaHiyouSubscription   : 受信ソケット:17車検検査費用と車検基本費用の編集
   * estimateListSubscription : 受信ソケット:ソケット仮01 // 部品代を更新したときの情報伝播 -> 各所
   * questionnaireSubscription : 受信ソケット:ソケット仮21
   * youtoSubscription        : 受信ソケット:ソケット仮20
   * confirmationSubscription : 受信ソケット:ソケット仮19
   * mileageSubscription      : 受信ソケット:ソケット仮23
   * memoSubscription         : 受信ソケット:ソケット仮24 // 車検メモ編集保存 -> 車検前画面
   * inspectSubscriptionDetail : 受信ソケット:ソケット仮26
   * frontSubscription        : 受信ソケット:ソケット仮25
   * ak7Subscribe             : 受信ソケット:ソケット仮34
   * jizenRecommendSubscribe  : 受信ソケット:ソケット仮27 // 受信ソケット:ソケット仮28
   * doTenkenSubscribe        : 受信ソケット:13するしない後日編集
   * inspectSeibiSubscribe    : 受信ソケット:ソケット仮06
   * optionSubscription       : 受信ソケット:ソケット仮12
   * couponSubscription       : 受信ソケット:ソケット仮11
   * jizenDisplayOrderSubscription : 受信ソケット:29車検項目の表示順並び替え
   * shohiyouSubscriptionComp : 受信ソケット:15車検諸費用の編集
   * extendsImageSubscription : 受信ソケット:35画像登録
   */

  constructor(vm?: Vue) {
    this.uketsukeCd = store.getters["ReservationDetail/uketsukeCd"];
    this.yoyakuNo = store.getters["ReservationDetail/yoyakuNo"];
    this.socket = store.getters["Socket/socket"];
    this.isUserMode = !!(vm && vm.$route && vm.$route.meta == "user");

    // Vue インスタンスが渡された場合は破棄時に購読解除をフックする
    if (vm) {
      this.bindLifecycle(vm);
    }
  }

  /**
   * ソケット通信情報メモ
   *  ・Vue側で扱うときの事前準備
   *  import { StompClient } from "@/service/StompClient";
   *  @Action("connect", { namespace: "Socket" })
   *  connectSocket: any;
   *  @Action("disconnect", { namespace: "Socket" })
   *  disconnectSocket: any;
   *  @Getter("socket", { namespace: "Socket" })
   *  socket: StompClient;
   *  
   *  ・接続
   *  Vue : this.connectSocket(宣言);
   *  TS  : store.dispatch("Socket/connect", 宣言);
   *  
   *  ・切断
   *  Vue : this.disconnectSocket();
   *  TS  : store.dispatch("Socket/disconnect");
   */
  connectSocket(callBack?: () => void) {
    if (this.disposed) { return; }
    this.watchConnection();
    if (!callBack) {
      store.dispatch("Socket/connect");
      return;
    }
    // 画面側の初期化は一度だけ。再接続時の購読復元は共通処理が担当する。
    let initialized = false;
    store.dispatch("Socket/connect", () => {
      if (this.disposed || initialized) { return; }
      initialized = true;
      if (callBack) { callBack(); }
    });
  }

  // 初回接続では取得せず、購読復元後に対象画面だけ最新状態を取得する。
  onReconnect(callback: () => void) {
    if (this.disposed) { return; }
    this.watchConnection();
    this.reconnectCallbacks.push(callback);
  }

  private watchConnection() {
    if (this.removeConnectedListener) { return; }
    this.hasConnected = this.checkSocket();
    this.removeConnectedListener = this.socket.onConnected(() => {
      if (this.disposed) { return; }
      const reconnected = this.hasConnected;
      this.hasConnected = true;
      // 古い接続の購読IDは無効。新しい接続にUNSUBSCRIBEを送らない。
      this.subscribeList = {};
      Object.keys(this.subscriptionDefinitions).forEach(key => this.subscribeOne(key));
      if (reconnected) { this.reconnectCallbacks.forEach(callback => callback()); }
    });
  }

  private registerSubscription(key: string, destination: string, callback: any) {
    if (this.disposed || this.subscriptionDefinitions[key]) { return; }
    this.watchConnection();
    this.subscriptionDefinitions[key] = { destination, callback };
    this.subscribeOne(key);
  }

  private subscribeOne(key: string) {
    if (this.disposed || !this.checkSocket() || this.subscribeList[key]) { return; }
    const definition = this.subscriptionDefinitions[key];
    this.subscribeList[key] = this.socket.client.subscribe(definition.destination, definition.callback);
  }

  checkSocket() {
    if (!this.socket || typeof this.socket.isConnected !== "function") {
      return false;
    }
    return this.socket.isConnected();
  }

  disconnectSocket() {
    // this.socket.disconnect();
    store.dispatch("Socket/disconnect");
  }

  /**
   * Quick見積用の処理
   * ランダム文字を生成してセット。以後その値を使いまわしながら画面切り替えることで識別情報として機能させる
   */
  randomString(): string {
    let len = 24;
    let str = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890";
    let strLen = str.length;
    let result = "";

    for (let i = 0; i < len; i++) {
      result += str[Math.floor(Math.random() * strLen)];
    }

    return `qm${result}`;
  }

  makeSocketKey() {
    this.socketPath = this.randomString();
    return this.socketPath;
  }

  /**
   * Vue のライフサイクルに破棄処理をぶら下げる
   * keep-alive コンポーネントの deactivated もケア
   */
  bindLifecycle(vm: Vue) {
    const cleanup = () => this.freeSocketResources();
    vm.$once("hook:beforeDestroy", cleanup);
    vm.$once("hook:deactivated", cleanup);
  }

  /*各種ソケットの作成 */
  socketEntry(key: any, callback: any, ignoreSelfUpdate?: boolean) {
    this.registerSubscription(key,
      "" + this.socketMap[key].main + this.uketsukeCd + this.yoyakuNo + this.socketMap[key].sub,
      (frame: any) => {
        if (this.disposed || (ignoreSelfUpdate && this.utils.isSelfSocket(frame, this.isUserMode))) {
          // 自画面が実行したAPIから受信した場合は無視
          return;
        }
        callback(frame);
      }
    );
  }

  // 受信ソケット:ソケット仮07
  socketInspectQm(callback: any) {
    this.registerSubscription("inspectSeibiSubscribeQm",
      `/connect/inspect-seibi-qm/${this.socketPath}/completed`,
      (frame: any) => { if (!this.disposed) { callback(frame); } }
    );
  }

  /* 終了時ソケット解放 */
  freeSocketResources() {
    this.disposed = true;
    this.reconnectCallbacks = [];
    if (this.removeConnectedListener) {
      this.removeConnectedListener();
      this.removeConnectedListener = null;
    }
    // destroyed()の中で呼び出されるので処理速度を重視する
    for (const key of Object.keys(this.subscribeList)) {
      const sub = this.subscribeList[key];
      if (this.checkSocket() && sub && typeof sub.unsubscribe === "function") {
        sub.unsubscribe();
      }
      delete this.subscribeList[key];
    }
    this.subscribeList = {};
    this.subscriptionDefinitions = {};
  }
  
}


